module.exports = __webpack_public_path__ + "static/img/BH@3x.de2804c8.jpg";